import React, { useMemo } from "react";
import "./AssessShared.css";

export default function AssessmentPagination({
  page = 1,
  pageSize = 20,
  totalCount = 0,
  onPageChange = () => {},
  onPageSizeChange = () => {},
}) 
{

  const totalPages = useMemo(() => {
    const safeSize = Number(pageSize) || 1;
    const safeTotal = Number(totalCount) || 0;
    return Math.max(1, Math.ceil(safeTotal / safeSize));
  }, [pageSize, totalCount]);

  const canPrev = page > 1;
  const canNext = page < totalPages;


  return (
    <div className="assess-pagination">
        <div className="assess-pagination__meta">
          <span>
            Page {page} of {totalPages}
          </span>
          <select
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            aria-label="Items per page"
          >
             <option value={5}>5 / page</option>
            <option value={10}>10 / page</option>
            <option value={20}>20 / page</option>
            <option value={50}>50 / page</option>
          </select>
          <span>{totalCount} total</span>
        </div>

        <div className="assess-pagination__actions">
          <button type="button" disabled={!canPrev} onClick={() => onPageChange(page - 1)}>
            Previous
          </button>
          <button type="button" disabled={!canNext} onClick={() => onPageChange(page + 1)}>
            Next
          </button>
        </div>
      </div>
  );
}
